// extracted by mini-css-extract-plugin
var _1 = "OfficeModal__backdrop--Ky5tk OfficeModal__backdropDisplay--Rhw2C";
var _2 = "OfficeModal__backdropDisplay--Rhw2C";
var _3 = "OfficeModal__backdropScroll--yZwew OfficeModal__backdropShared--S_SFX OfficeModal__fullSize--VZDNP OfficeModal__backdropDisplay--Rhw2C";
var _4 = "OfficeModal__backdropShared--S_SFX OfficeModal__fullSize--VZDNP";
var _5 = "OfficeModal__backdropWrapper--ie7wJ OfficeModal__backdropShared--S_SFX OfficeModal__fullSize--VZDNP";
var _6 = "OfficeModal__fullSize--VZDNP";
var _7 = "OfficeModal__main--oJEwm";
var _8 = "OfficeModal__mainScroll--IgIuq";
export { _1 as "backdrop", _2 as "backdropDisplay", _3 as "backdropScroll", _4 as "backdropShared", _5 as "backdropWrapper", _6 as "fullSize", _7 as "main", _8 as "mainScroll" }
